export const labels = {
  slug: "/recipes/",
  searchPlaceHolder: "Search for recipes, ingredients, products",
  searchBtn: "Search",
  philadelphiaTypeName: "philadelphia",
  noRecipes: "No recipes found",
  selctedFiltersTitle: "SELECTED FILTERS",
  sortRecipes: {
    sortDefaultOption: "",
    sortLabel: "SORT BY",
    sortDropdownOptions: [
      {
        label: "Newest first",
        value: "last_modified_date desc",
      },
      {
        label: "Name",
        value: "title asc",
      },
    ],
  },
  filterRecipes: {
    filterLabel: "Filter Recipes",
    resetFilters: "Reset all filters",
    applyFilters: "Apply Filters",
    filterGroupNames: {
      typeOfPhiladelphia: "Type of Philadelphia",
      typeOfDish: "Type of Dish",
      sector: "Sector",
    },
  },
}
